<template>
    <div :class="$style['review-report-ifame']">
        <el-dialog :title="curtitle" :visible="showDialog" class="goods-review-dialog" @close="closeDialog">
            <video v-if="isVideo" width="100%" :src="$publicResourcesUrl + detail.contentUrl" :poster="$publicResourcesUrl + detail.imageUrl" controls></video>
            <poster-template v-else :detail="detail"></poster-template>
        </el-dialog>
    </div>
</template>
<script>
import posterTemplate from './poster-template'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {}
    },
    isVideo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    curtitle () {
      return this.isVideo ? '移动端视频预览' : '移动端海报预览'
    }
  },
  components: { posterTemplate },
  data () {
    return {
      apiServer: this.$apiServerMobile
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style lang="less" module>
.review-report-ifame{
:global
.goods-review-dialog{
    overflow: hidden;
    .el-dialog{
        margin-top: 3%!important;
        height: 94%;
        display: flex;
        width: 30%;
        min-width: 350PX;
        max-width: 400PX;
        max-height: 812PX;
        min-height: 667PX;
        flex-direction:column;
        .el-dialog__header{
            .el-dialog__title{
                width: 100%;
                text-align: center;
                display: block
            }
        }
        .el-dialog__body{
            border: 1px dashed #4A91FD;
            padding: 5px;
            flex: 1
        }
    }

}
}
.review-iframe{
    width: 100%;
    height: 100%;
}
</style>
